(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $dIxxU = parcelRequire("dIxxU");
const $01052984e3d91a60$var$API_Cours_USD = `${"https://overgold.app/"}v4/rs/price/usd`;
const $01052984e3d91a60$var$API_Cours_EUR = `${"https://overgold.app/"}v4/rs/price/eur`;
const $01052984e3d91a60$var$API_Wallets = `${"https://overgold.app/"}v4/api/status/total`;
const $01052984e3d91a60$var$today = new Date();
$01052984e3d91a60$var$today.setDate($01052984e3d91a60$var$today.getDate());
const $01052984e3d91a60$var$yesterday = new Date($01052984e3d91a60$var$today);
$01052984e3d91a60$var$yesterday.setDate($01052984e3d91a60$var$yesterday.getDate() - 1);
const $01052984e3d91a60$var$formattedToday = $01052984e3d91a60$var$today.toISOString().split("T")[0];
const $01052984e3d91a60$var$formattedYesterday = $01052984e3d91a60$var$yesterday.toISOString().split("T")[0];
const $01052984e3d91a60$var$API_Turnover = `${"https://api.chain.overgold.app/"}api/stats/asset/${$01052984e3d91a60$var$formattedYesterday}/${$01052984e3d91a60$var$formattedToday}`;
const $01052984e3d91a60$var$errorMassage = "No data";
async function $01052984e3d91a60$var$getRate() {
    try {
        const responseUSD = await (0, $dIxxU.default).get($01052984e3d91a60$var$API_Cours_USD);
        const dataUSD = responseUSD.data;
        const priceUSD = Number(dataUSD.price).toFixed(2);
        if (priceUSD) localStorage.setItem("priceUsd", priceUSD);
    } catch (error) {
        console.log("Error fetching USD rate:", error);
    }
    try {
        const responseEUR = await (0, $dIxxU.default).get($01052984e3d91a60$var$API_Cours_EUR);
        const dataEUR = responseEUR.data;
        const priceEUR = Number(dataEUR.price).toFixed(2);
        if (priceEUR) localStorage.setItem("priceEur", priceEUR);
    } catch (error) {
        console.log("Error fetching EUR rate:", error);
    }
    try {
        const responseWallets = await (0, $dIxxU.default).get($01052984e3d91a60$var$API_Wallets);
        const dataWallets = responseWallets.data.total;
        const walletsCount = Number(dataWallets) + 3698;
        if (walletsCount) localStorage.setItem("walletsCount", walletsCount);
    } catch (error) {
        console.log("Error fetching wallets count:", error);
    }
    try {
        const response = await (0, $dIxxU.default).get($01052984e3d91a60$var$API_Turnover);
        const data = response.data;
        const amountWithFee = data.stats.dailyStats.amountWithFee.find((item)=>item.denom === "ovg")?.amount ?? "0";
        const withdraw = data.stats.dailyStats.withdraw.find((item)=>item.denom === "ovg")?.amount ?? "0";
        const issued = data.stats.dailyStats.issued.find((item)=>item.denom === "ovg")?.amount ?? "0";
        const SATOSHI_AMOUNT = 100000000;
        const turnover = ((parseInt(amountWithFee) + parseInt(withdraw) + parseInt(issued)) / SATOSHI_AMOUNT).toFixed(2);
        localStorage.setItem("turnover", turnover);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
    const priceEurElement = document.getElementById("priceEur");
    priceEurElement.innerHTML = localStorage.getItem("priceEur") || $01052984e3d91a60$var$errorMassage;
    const priceUsdElement = document.getElementById("priceUsd");
    priceUsdElement.innerHTML = localStorage.getItem("priceUsd") || $01052984e3d91a60$var$errorMassage;
    const walletCountElement = document.getElementById("walletsCount");
    walletCountElement.innerHTML = localStorage.getItem("walletsCount") || $01052984e3d91a60$var$errorMassage;
    const turnoverElement = document.getElementById("turnover");
    turnoverElement.innerHTML = localStorage.getItem("turnover") || $01052984e3d91a60$var$errorMassage;
}
document.addEventListener("DOMContentLoaded", ()=>{
    $01052984e3d91a60$var$getRate();
});

})();
//# sourceMappingURL=index.e772be42.js.map
